export class UserSetting {
    public id:number|null;
    public user_id:number;
    public name:string;
    public data:any;


    constructor(data:UserSettingData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.user_id = 0;
            this.name = "";
            this.data = "";
        }
        else
        {
            this.id = data.id;
            this.user_id = data.user_id;
            this.name = data.name;
            this.data = data.data;
        }
    }

    public resetToDefaults():void {
        this.id = null;
        this.user_id = 0;
        this.name = "";
        this.data = "";
    }

    public serializeData():UserSettingData {
        return {
            id: this.id,
            user_id: this.user_id,
            name: this.name,
            data: this.data,
        }
    }
}

export type UserSettingData = {
    id:number|null;
    user_id:number;
    name:string;
    data:any;
}
